import { render, staticRenderFns } from "./purchaseInformationMaintenance.vue?vue&type=template&id=6446a2e8&scoped=true&"
import script from "./purchaseInformationMaintenance.vue?vue&type=script&lang=js&"
export * from "./purchaseInformationMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./purchaseInformationMaintenance.vue?vue&type=style&index=0&id=6446a2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446a2e8",
  null
  
)

export default component.exports